import { CombinedGraphQLErrors } from '@apollo/client';
import { EMPTY } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
  private router = inject(Router);

  handle(error: unknown) {
    if (CombinedGraphQLErrors.is(error)) {
      const errors = error.errors;

      for (const err of errors) {
        if (!err.extensions) throw err;

        if (err.extensions.code === 'FORBIDDEN') {
          this.router.navigate(['/errors', 401]);
          return EMPTY;
        }
      }

      return EMPTY;
    }

    throw error; // Rethrow the error if it's not handled
  }
}
